var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"div_preload_two"},[_c('p',{staticClass:"text_preload text-center",domProps:{"innerHTML":_vm._s(_vm.mensaje)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div_preload"},[_c('p',{staticClass:"d-block"},[_c('img',{attrs:{"src":require("../../assets/img/loader.gif"),"alt":"loading...","height":"64","width":"64"}})])])
}]

export { render, staticRenderFns }